@if (nutrients?.length > 0) {
  @if (!isMobile) {
    <section class="nutrient-list">
      <header class="nutrient-list__header">
        <p class="nutrient-list__title">{{ nutrientListTitle }}</p>
        <div class="nutrient-list__bar-legend">
          <span class="nutrient-list__bar-legend__item">
            <app-icon class="nutrient-list__icon" [name]="IconName.minus"></app-icon>
          </span>
          <span class="nutrient-list__bar-legend__item">
            <app-icon class="nutrient-list__icon" [name]="IconName.plus"></app-icon>
          </span>
        </div>
        <div class="nutrient-list__tags-legend">
          <span class="nutrient-list__tags-legend__item">
            <span>{{ 'sr-xray_column_title_Main_influencers' | translateKey }}</span>
            <span
              class="nutrient-list__info-icon"
              [matTooltipPosition]="'above'"
              matTooltipHideDelay="1"
              matTooltip="{{ 'sr-xray_main_influencers_popin' | translateKey }}"
              matTooltipClass="tooltip-arrow-down-light"
              #tooltip="matTooltip"
            >
              <app-icon class="nutrient-list__icon" [name]="IconName.info"></app-icon>
            </span>
          </span>
        </div>
      </header>
      <div class="nutrient-list__list-container">
        @for (nutrient of nutrients; track nutrient.nutrient) {
          <div class="nutrient-list__item">
            <div class="nutrient-list__item__left">
              <p class="nutrient-list__label">
                {{ getNutrientLabel(nutrient.nutrient.id, nutrientType) }}
                <span class="nutrient-list__label__unit">{{ getNutrientUnit(nutrient.nutrient.unit) }}</span>
              </p>
              <div class="nutrient-list__nutrient-bar-block">
                <p class="nutrient-list__nutrient-bar-block__value-left">{{ hideCutOff ? null : nutrient.cutOff.low }}</p>
                <app-nutrients-bar class="nutrient-list__nutrient-bar" [id]="'desktop'" [nutrients]="nutrient"></app-nutrients-bar>
                <p class="nutrient-list__nutrient-bar-block__value-right">{{ hideCutOff ? null : nutrient.cutOff.high }}</p>
              </div>
            </div>
            <div class="nutrient-list__tag-list">
              @for (influencer of nutrient.influencers; track influencer.key) {
                <div class="nutrient-list__tag-item">
                  @let influencerLabel = getInfluencerLabel(influencer);
                  <span
                    class="nutrient-list__info-icon"
                    [matTooltipPosition]="'above'"
                    matTooltipHideDelay="1"
                    matTooltip="{{ 'description-criteria_consult' | translateKey }} {{ influencerLabel }} "
                    matTooltipClass="tooltip-arrow-down"
                    #tooltip="matTooltip"
                  >
                    @if (!!influencerLabel) {
                      <rc-tag
                        [size]="RCTagSize.XS"
                        [text]="influencerLabel"
                        [isInteractive]="true"
                        (click)="showInfluencerDescriptionPopin(influencer)"
                      ></rc-tag>
                    }
                  </span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </section>
  } @else {
    <section class="nutrient-list">
      <p class="nutrient-list__title__mobile">{{ nutrientListTitle }}</p>
      <div class="nutrient-list__list-container__mobile">
        @for (nutrient of nutrients; track nutrient.nutrient) {
          <div class="nutrient-list__item-mobile">
            <p class="nutrient-list__label-mobile">
              {{ getNutrientLabel(nutrient.nutrient.id, nutrientType) }}
              <span class="nutrient-list__label__unit">{{ getNutrientUnit(nutrient.nutrient.unit) }}</span>
            </p>
            <div class="nutrient-list__nutrient-bar-wrapper-mobile">
              <div class="nutrient-list__nutrient-bar-mobile">
                <div class="nutrient-list__bar-legend-mobile">
                  <span>
                    <app-icon class="nutrient-list__icon" [name]="IconName.minus"></app-icon>
                  </span>
                  <span>
                    <app-icon class="nutrient-list__icon" [name]="IconName.plus"></app-icon>
                  </span>
                </div>
                <div class="nutrient-list__nutrient-bar-block">
                  <p class="nutrient-list__nutrient-bar-block__value-left">{{ hideCutOff ? null : nutrient.cutOff.low }}</p>
                  <app-nutrients-bar [id]="'mobile'" [nutrients]="nutrient"></app-nutrients-bar>
                  <p class="nutrient-list__nutrient-bar-block__value-right">{{ hideCutOff ? null : nutrient.cutOff.high }}</p>
                </div>
              </div>
            </div>
            <div class="nutrient-list__tags-legend-mobile">
              <span>
                {{ 'sr-xray_column_title_Main_influencers' | translateKey }}
              </span>
            </div>
            <div class="nutrient-list__tag-list-mobile">
              @for (influencer of nutrient.influencers; track influencer.key) {
                <div class="nutrient-list__tag-item">
                  @let influencerLabel = getInfluencerLabel(influencer);
                  @if (!!influencerLabel) {
                    <rc-tag [size]="RCTagSize.XS" [text]="influencerLabel"></rc-tag>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </section>
  }
}
